import { Box, styled, Typography } from '@mui/material';

export const SidebarContainer = styled(Box)`
  & > div:first-child {
    padding: 0 16px;
  }
  padding: 20px 0 0 0;
  height: 100vh;
`;

export const SidebarContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  height: calc(100vh - 55px);
`;

export const SectionTitle = styled(Typography)(
  () => `
  margin-left: 0.9375rem;
  padding-top: 10px;
`,
);

export const ProductTitle = styled(Typography)(
  () => `
  margin-right: 1rem;  
`,
);

export const UnCheckedContainer = styled(Box)`
  padding: 0rem 0rem 15rem 0rem;
`;

export const CheckedContainer = styled(Box)`
  padding: 0 1.625rem 16.6875rem 1.625rem;
`;

export const ComponentSettingContainer = styled(Box)`
  padding: 1.625rem 1.625rem 10rem 1.625rem;
`;
